import axiosInstance from "../../services/axiosInstance";
import recreateAccessTokenAction from "../auth/RecreateAccessTokenAction";
import {
  VIDEO_UPLOAD_CM_FAILURE,
  VIDEO_UPLOAD_CM_REQUEST,
  VIDEO_UPLOAD_CM_SUCCESS,
} from "../types";

const VideoUploadCmAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: VIDEO_UPLOAD_CM_REQUEST,
    });
    // Don't pass headers - let axios interceptor handle Authorization
    // and let axios automatically set Content-Type with boundary for FormData
    axiosInstance
      .post(`v1/upload_cm_video/`, data)
      .then((response) => {
        dispatch({
          type: VIDEO_UPLOAD_CM_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: VIDEO_UPLOAD_CM_FAILURE,
          payload: error.message,
        });
        if (error.message === "Request failed with status code 403") {
          dispatch(recreateAccessTokenAction());
        }
      });
  };
};

export default VideoUploadCmAction;
